import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "router-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_share_wechat = _resolveComponent("share-wechat");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [(_openBlock(), _createBlock(_KeepAlive, null, [$options.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: $options.path
    })) : _createCommentVNode("", true)], 1024)), !$options.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: $options.path
    })) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_share_wechat)]);
}